import createVueApp from '@phoenix/createVueApp';
import BoutiqueStockAvailabilityModal from '@maison/components/product/BoutiqueStockAvailabilityModal.vue';
Array.from(document.querySelectorAll<HTMLElement>('.phoenix-boutique-stock-availability-modal')).forEach((el) => {
  const app = createVueApp({}, true);
  app.component('BoutiqueStockAvailabilityModal', BoutiqueStockAvailabilityModal);
  app.mount(el);
});
